module.exports = __webpack_public_path__ + "static/media/face.41e7dd39.svg";